import { toast } from "react-toastify"

export const ToastResponse = (statusCode, message) => {
    if (statusCode === 200) {
        toast.success(message)
    } else {
        toast.error(message)
    }
}